export default "__VITE_ASSET__2BjOCeXT__"